module.exports = __webpack_public_path__ + "img/bn_left.a3540ee4.png";